"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { useState } from "react";
const projects = [{
  id: 1,
  title: "Modern Kitchen Remodel",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/modern_kitchen_remodel_project.png"
}, {
  id: 2,
  title: "Backyard Landscaping Transformation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/backyard_landscaping_transformation.png"
}, {
  id: 3,
  title: "Exterior House Painting",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/exterior_house_painting_project.png"
}, {
  id: 4,
  title: "Bathroom Renovation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/bathroom_renovation_project.png"
}, {
  id: 5,
  title: "Deck Construction",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/deck_construction_project.png"
}, {
  id: 6,
  title: "Wooden Deck Renovation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/wooden_deck_renovation_project.png"
}, {
  id: 7,
  title: "Driveway Powerwashing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/driveway_powerwashing_project.png"
}, {
  id: 8,
  title: "Composite Deck Installation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/composite_deck_installation_project.png"
}, {
  id: 9,
  title: "Living Room Remodeling",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/living_room_remodeling_project.png"
}, {
  id: 10,
  title: "Front Yard Garden Design",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/front_yard_garden_design.png"
}, {
  id: 11,
  title: "Basement Finishing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/basement_finishing_project.png"
}, {
  id: 12,
  title: "Multi-Level Deck Construction",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/multi_level_deck_construction_project.png"
}, {
  id: 13,
  title: "Patio Installation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/patio_installation_project.png"
}];
function ProjectCard({
  project,
  index
}: {
  project: typeof projects[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  const [isHovered, setIsHovered] = useState(false);
  return <div ref={ref} data-index={index} className={`transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
    transitionDelay: isVisible ? `${index * 50}ms` : "0ms"
  }}>
      <Card className="overflow-hidden cursor-pointer group relative h-full bg-white border border-muted shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-0.5" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        <CardContent className="p-0 relative">
          <div className="relative overflow-hidden aspect-[4/3]">
            <img src={project.image} alt={project.title} className={`w-full h-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isHovered ? "scale-102" : "scale-100"}`} />
            <div className={`absolute inset-0 bg-primary/60 backdrop-blur-sm flex items-center justify-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isHovered ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}>
              <h3 className="text-foreground-primary font-semibold text-lg px-4 text-center">
                {project.title}
              </h3>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}
export default function Portfolio() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.1
  });
  return <section id="portfolio" ref={ref} className="py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-16 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-foreground mb-4">
            Portfolio
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Explore our recent projects showcasing quality craftsmanship and attention to detail
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {projects.map((project, i) => <ProjectCard key={project.id} project={project} index={i} />)}
        </div>
      </div>
    </section>;
}